export default __webpack_public_path__ + "static/kenny-e350ae2705da374a0954f69db7b8a3e0.jpeg";